import { render } from "./ViewableStarRating.vue?vue&type=template&id=705d46f8&scoped=true"
import script from "./ViewableStarRating.vue?vue&type=script&lang=js"
export * from "./ViewableStarRating.vue?vue&type=script&lang=js"

import "./ViewableStarRating.vue?vue&type=style&index=0&id=705d46f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705d46f8"]])

export default __exports__